import React from 'react';
import classNames from 'classnames';

/*Highly opinionated grid div.
  Its n columns are evenly spaced.
  Based on the default props of UI Toolkit's Grid component.
 */
export const SimpleGrid: React.FC<{
  columnCount?: number;
  className?: string;
  baseline?: boolean;
  wrap?: boolean;
  children?: React.ReactNode;
}> = ({ columnCount = 1, children, className, baseline, wrap = false }) => {
  const gridCols = `md:grid-cols-${columnCount}`;
  const alignment = !!baseline ? 'md:items-baseline' : 'items-end';
  return (
    <div
      className={classNames('grid', gridCols, 'gap-4 text-left', alignment, className, {
        'lg:whitespace-nowrap': !wrap,
      })}
    >
      {children}
    </div>
  );
};
